import React, { useEffect, useReducer, useRef  } from "react";

// Interface for component props
interface CallListFilterProps {
	onClick: () => void;
	title: string;
}

export const CallListFilter = ( props: CallListFilterProps ) => {

	return (
		<section className={"select-filter-wrap"}>
			<div className={"select-filter"} onClick={ props.onClick }>
				<p className={"select-filter-btn"}>&#x208A;</p>
				<p className={"select-filter-text"}>{ props.title }</p>
			</div>
		</section>
	);
};